'use strict';
const _ = require('lodash');
const SENDING_STATE = 0;
const SENT_STATE = 1;

function controller ($scope, $timeout, $filter, $window, $q, viewport, similarVehiclesService, listingService,
    localStorageService, alsService, pageStateService, sessionStorageService) {
    const ctrl = this,
        UNKNOWN_BS_ID = 29599,
        RPP = 8,
        CONFIG_ID = {
            SV: 0
        };

    let geoLocation = {},
        zipCode = getLocalStoredZip();

    ctrl.getCarsPerPage = getCarsPerPage;
    ctrl.trackImpression = trackImpression;
    ctrl.trackShow = trackShow;
    ctrl.updateShow = updateShow;
    ctrl.trackSwipeLeft = trackSwipeLeft;
    ctrl.trackSwipeRight = trackSwipeRight;
    ctrl.saveSimilarVehicle = saveSimilarVehicle;
    ctrl.goToCaptiveSrp = goToCaptiveSrp;
    ctrl.searchSimilarVehicle = searchSimilarVehicle;
    ctrl.showViewMoreTile = showViewMoreTile;
    ctrl.alsClickThrufromDrv = alsClickThrufromDrv;
    ctrl.sendAdditionalLead = sendAdditionalLead;
    ctrl.getDisplaySubmittalStatusForResult = getDisplaySubmittalStatusForResult;
    $scope.goToVdp = goToVdp;
    $scope.showModule = false;
    $scope.showNoResults = false;

    init();

/////////////////////////////////////////////////////////
    function init() {
        if (!$scope.pageName) {
            $scope.pageName = '';
        }

        listingService.getListing().then((listing)=> {
            $scope.listing = listing.listingDetailDto;
            $scope.zipcode = zipCode || $scope.listing.zipcode;
            if (shouldCallGetResults($scope.listing)) {
                getResults($scope.listing );
            }
        });
    }

    function shouldCallGetResults() {
        let newStk;
        let usedStk;

        if (!!$scope.listing.price && !!$scope.listing.bodystyleId && $scope.listing.bodystyleId != UNKNOWN_BS_ID) {
            newStk = !!($scope.listing.stockTypeCode === "New" && $scope.listing.similarVehiclesNew > 1);
            usedStk = !!(($scope.listing.stockTypeCode === "Used" || $scope.listing.stockTypeCode === "CPO") && $scope.listing.similarVehiclesUsed > 1);
        }
        return newStk || usedStk;
    }

    function isConquestSv() {
        if ($scope.listing.stockTypeCode.toLowerCase() === 'new') {
            return $scope.listing.similarVehiclesNew === 0;
        } else {
            return $scope.listing.similarVehiclesUsed === 0;
        }
    }

    function showViewMoreTile() {
        var display = false;
        if (!isConquestSv()) {
            if ($scope.results.numberOfListings > 9) {
                display = true;
            }
        }
        return display;
    }

    function getResults(listing) {
        $scope.stockType = listing.stockTypeCode === 'New' ? 'new' : 'used';
        $scope.listingId = listing.listingId;
        similarVehiclesService.getDrvListings(groomListingObject(listing), $scope.pageName).then(function (response) {
            $scope.results = response.data;
            $scope.captiveSrp = createCaptiveSRPLink($scope.results.drvSearchCriteria);
            ctrl.updateShow();
            if (showViewMoreTile()) {
                addViewMoreTileToCarousel();
            }
            $timeout(function () {
                $scope.calculateDomInfo();
            });
        });
    }

    function groomListingObject() {
        var listingObj = {
            perPage: RPP,
            filterOutLId: $scope.listing.listingId,
            prMn: $scope.listing.price,
            bsId: $scope.listing.bodystyleId,
            dlId: $scope.listing.sellerId,
            stkTypCode: ($scope.listing.stockTypeCode === "New" ) ? "N" : "U",
            mdId: $scope.listing.modelId,
            mkId: $scope.listing.makeId,
            configId: CONFIG_ID.SV
        };

        return listingObj;
    }

    function createCaptiveSRPLink(obj) {
        var link = "/for-sale/searchresults.action/?rd=9999&zc=" + zipCode;
        angular.forEach(obj, function (v, i) {
            if (v !== null) {
                if (typeof v == 'object') {
                    angular.forEach(v, function (v2) {
                        link += "&" + i + "=" + v2;
                    });
                } else {
                    link += "&" + i + "=" + v;
                }
            }
        });
        return link;
    }

    function saveSimilarVehicle() {
        similarVehiclesService.saveSimilarVehicle($scope.listing);
    }

    function goToCaptiveSrp(evt) {
        saveSimilarVehicle();

        alsService.clickthru({
            listingId: $scope.listing.listingId,
            pageToId: 2102,
            pageFromId: $scope.listing.stockTypeCode === 'New'
                ? 2294
                : 2295
        });

        if (evt.shiftKey || evt.metaKey || evt.ctrlKey || evt.which === 2) {
            null;
        } else {
            gotToHref();
        }
    }

    function goToVdp(evt, resultVehicleId, index) {
        const keys = ['srp-np-listings', 'srp-np-pagination', 'srp-np-count'];
        for (let i = 0; i < keys.length; i++) {
            sessionStorageService.removeItem(keys[i]);
        }

        alsClickThrufromDrv({
            listingId: $scope.listing.listingId,
            stockType: $scope.listing.stockTypeCode === 'New' ? 'new' : 'used',
            toCaptiveSRP: false,
            page: $scope.pageName,
            horizontalPosition: index
        });

        if (evt.shiftKey || evt.metaKey || evt.ctrlKey || evt.which === 2) {
            null;
        } else {
            gotToHref(resultVehicleId);
        }
    }

    function gotToHref(resultVehicleId) {
        if (resultVehicleId) {
            $window.location.assign("/vehicledetail/detail/" + resultVehicleId + "/overview/");
        } else {
            $window.location.assign($scope.captiveSrp);
        }
    }

    function searchSimilarVehicle() {
        return $scope.captiveSrp;
    }

    function shouldShowNoResults() {
        return similarVehiclesService.shouldShowNoResults();
    }

    function updateShow() {
        $scope.resultsShow = ($scope.results.numberOfListings < 8) ? $scope.results.numberOfListings : 8;
        if ($scope.results.numberOfListings >= 2) {
            $scope.showModule = true;
            ctrl.trackShow();
            ctrl.trackImpression();
        } else {
            $scope.showNoResults = shouldShowNoResults();
        }
        updateTitle();
    }

    function updateTitle() {
        $scope.results.title = 'Similar Cars at this Dealership';
        if ($scope.listing.isTeslaDealerGroup){
            $scope.results.title = 'Similar Cars at Tesla';
        }
    }

    function addViewMoreTileToCarousel() {
        $scope.results.listingResults.push({});
    }

    function getCarsPerPage() {
        if (viewport.isTablet()) {
            return 3;
        } else if (viewport.isAtLeastDesktop()) {
            return 4;
        } else {
            return null;
        }
    }

    function trackImpression() {
        var impressionLog;

        impressionLog = {
            listingId: $scope.listing.listingId,
            modelYearId: $scope.listing.modelYearId,
            makeId: $scope.listing.makeId,
            modelId: $scope.listing.modelId,
            trimId: $scope.listing.trimId,
            stockTypeCode: $scope.listing.stockTypeCode,
            sellerId: $scope.listing.sellerId,
            primaryFeedSourceId: $scope.listing.primaryFeedSourceId,
            localOfferId: $scope.listing.localOfferId,
            affiliateAgentId: $scope.listing.affiliateAgentId,
            pageToId: $scope.listing.stockTypeCode === 'New'
                ? 2294
                : 2295
        };
        /* istanbul ignore next */
        if ($scope.pageName === 'thankyou-modal') {
            impressionLog.page = 'thankyou';
        }

        alsService.impression(impressionLog);
    }

    function trackShow() {
        if (!$scope.disableCustomlinkFire){
            var oldProp64,
                newProp64 = '';
            /* istanbul ignore next */
            if (oldProp64) {
                newProp64 = oldProp64 + ',';
            }

            newProp64 += 'DRV' + $scope.stockType;
        }
    }

    function trackSwipeLeft() {
        pageStateService.push('event', {eventName: "custom-link"}, true);
    }

    function trackSwipeRight() {
        pageStateService.push('event', {eventName: "custom-link"}, true);
    }

    function getLocalStoredZip() {
        const userData = localStorageService.getItem('Cars.userData');
        return (userData !== null) ? JSON.parse(userData).zip : null;
    }

    function setGeoObject () {
        let clientLatitude = sessionStorageService.getItem('carsClientGeoLocationLatitude') || false,
            clientLongitude = sessionStorageService.getItem('carsClientGeoLocationLongitude') || false,
            hasLatitude = clientLatitude,
            hasLongitude = clientLongitude;
        // creates a geolocation object when available to merge to loggingData to be passed
        if (hasLatitude && hasLongitude) {
            geoLocation = {
                "latitude" : hasLatitude,
                "longitude" : hasLongitude
            };
        }
    }
    function addClientLatLong (loggingData) {
        setGeoObject();
        if (geoLocation !== {}) {
            loggingData = { ...loggingData, ...geoLocation };
        }

        return loggingData;
    }

    function alsClickThrufromDrv(options) {
        let pageFromId,
            pagesByName = {
                vehicleDetail: 2104,
                srp: 2102,
                drvVDPNewConquest:2334,
                drvVDPUsedConquest:2333,
                drvTYPNewConquest:2336,
                drvTYPUsedConquest:2335,
                drvNew:2294,
                typNew:2298,
                typUsed:2299,
                drvUsed:2295

            },
            pageToId = options.toCaptiveSRP ? pagesByName.srp : pagesByName.vehicleDetail,
            log;

        if (options.page && options.page === 'thankyou') {
            if (options.stockType.toLowerCase() === 'new') {
                pageFromId = (options.isConquest) ? pagesByName.drvTYPNewConquest : pagesByName.typNew;
            } else {
                pageFromId = (options.isConquest) ? pagesByName.drvTYPUsedConquest : pagesByName.typUsed;
            }
        } else if (options.stockType.toLowerCase() === 'new') {
            pageFromId = (options.isConquest) ? pagesByName.drvVDPNewConquest : pagesByName.drvNew;
        } else {
            pageFromId = (options.isConquest) ? pagesByName.drvVDPUsedConquest : pagesByName.drvUsed;
        }

        log = {
            listingId: options.listingId,
            pageFromId,
            pageToId,
            horizontalPosition: options.horizontalPosition,
            publicConsumerId : _.get(window.CARS, "digitalData.user.profileInfo.publicConsumerId", 0),
            publicDeviceId : _.get(window.CARS, "digitalData.user.profileInfo.publicDeviceId", 0)
        };
        log = addClientLatLong(log);
        alsService.clickthru(log);
    }

    function sendAdditionalLead(listingId, index, resultState) {
        if (resultState !== 0 && resultState !== 1){
            let selectedListing = $scope.results.listingResults[index];
            if (!angular.isDefined(selectedListing)) {
                return;
            }

            selectedListing.submitted = SENDING_STATE;

            getPreviousFormData()
                .then(previousListing => {
                    let thisCar = selectedListing.vehicle;
                    let formattedPrice = $filter('currency')(thisCar.price, '$', 0);
                    var rawMessage = ['I\'d also like to learn more about the',
                        thisCar.displayStockType,
                        thisCar.year,
                        thisCar.make,
                        thisCar.model,
                        thisCar.trim,
                        'you have listed on Cars.com for',
                        formattedPrice];

                    let newComment = _(rawMessage).filter( v => v != null).join(' ');
                    previousListing.comments = newComment;
                    localStorageService.setItem('Cars.emailFormData', JSON.stringify(previousListing));

                    return similarVehiclesService.sendAdditionalLead(selectedListing);
                })
                .catch(() => {
                    selectedListing.submitted = SENT_STATE;
                })
                .finally(() => {
                    selectedListing.submitted = SENT_STATE;
                });
        }
    }

    function getPreviousFormData() {
        return $q(function(resolve, reject){
            try {
            let previousFormData = JSON.parse(localStorageService.getItem('Cars.emailFormData'));
            resolve(previousFormData);
        } catch (e) {
            reject("Failed to fetch previous lead");
        }
        });
    }

    function getDisplaySubmittalStatusForResult(listing) {
        let result;
        switch (listing.submitted) {
            case SENDING_STATE:
                result = "Sending...";
                break;
            case SENT_STATE:
                result = "Sent";
                break;
            default:
                result = "Add";
                break;
        }

        return result;
    }
}

controller.$inject = [
    '$scope',
    '$timeout',
    '$filter',
    '$window',
    '$q',
    'viewport',
    'similarVehicles',
    'listingService',
    'localStorageService',
    'alsService',
    'pageStateService',
    'sessionStorageService'
];

export default controller;
